import {
    Spin,
    Typography,
    Space,
    Row,
    Col,
    PageHeader,
    Button,
} from 'antd';
import { useContext, useEffect, useState } from 'react';
import { CardModule, CreateModule, Module } from './components';
import { IWorkspace } from '../../../types/workspaces';
import { WorkspaceModuleContext } from './context/module.context';
import CardDataBase from '../../CardDataBase';
import { IWorkspaceModule } from './context/context.interface';

interface Props {
    workspace: IWorkspace;
}

const { Text } = Typography;

const ModulesContent = ({ workspace }: Props) => {
    const {
        loading,
        item,
        data,
        setItem,
        fetchData,
    } = useContext(WorkspaceModuleContext);

    const [openCreate, setOpenCreate] = useState<boolean>(false);

    useEffect(() => {
        if (!workspace?._id) return;
        fetchData();
    }, [workspace?._id]);

    return (
        <CardDataBase>
            {
                item && (
                    <Module
                        item={item}
                        open={!!item}
                        onClose={() => setItem(null)}
                    />
                )
            }

            {
                openCreate && (
                    <CreateModule
                        workspaceId={workspace?._id}
                        open={openCreate}
                        onClose={() => setOpenCreate(false)}
                    />
                )
            }

            <PageHeader
                title="Modules"
                style={{ padding: 0 }}
                extra={(
                    <Button
                        type="primary"
                        onClick={() => setOpenCreate(true)}
                    >
                        Create Module
                    </Button>
                )}
                footer={(
                    loading ? (
                        <Space size={8}>
                            <Spin />
                            <Text>
                                Loading modules...
                            </Text>
                        </Space>
                    ) : data.length ? (
                        <Row gutter={[14, 14]}>
                            {
                                data.map((item: IWorkspaceModule) => (
                                    <Col
                                        xs={24}
                                        lg={12}
                                        xl={8}
                                        xxl={6}
                                        key={item._id}
                                    >
                                        <CardModule
                                            key={item._id}
                                            item={item}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    ) : (
                        <Text>
                            No modules found
                        </Text>
                    )
                )}
            />
        </CardDataBase>
    );
};

export default ModulesContent;
